import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  NotificationHead_Set,
  NotificationPickingPending_Set,
} from "./SliceNotification";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import Notification_Breadcrumbs from "./Notification_BreadCrumbs";
import { GridDataSummaryColumns_Def } from "./Action";
import {
  Set_WmsInboundGRN_HeadObject_Init,
  Set_WmsInboundGRN_Init,
} from "../InboundGRN/SliceWmsInboundGRN";
import moment from "moment";
import FilterNotificationModal from "./component/FilterNotificationModal";
import { Set_HeadObject_Init as Set_HeadObject_Init_Vendor } from "../WmsInboundVendor/SliceWmsInboundVendor";
import { Set_HeadObject_Init as Set_HeadObject_Init_Return } from "../WmsInboundReturn/SliceWmsInboundReturn";

import { Set_HeadObject_Init as Set_HeadObject_Init_Outlet } from "../WmsInboundOutlet/SliceWmsInboundOutlet";
import CardComp, {
  InputDisplay,
} from "../../Component/Common/ReuseableComponent/Card";
import dayjs from "dayjs";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";
import { Box, useMediaQuery } from "@mui/material";

export default function NotificationSummary() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const [showModal, setShowModal] = useState(false);
  const [sGridrows, setGridrows] = useState([]);
  const [filterState, setFilterState] = useState({
    dateFrom: dayjs().startOf("month").toDate(),
    dateTo: dayjs().toDate(),
    v_InBound: "Y",
    v_PutAway: "Y",
    v_Picking: "Y",
    v_Loc: vRdxDBLocation[0]?.UID,
  });

  const [GridDataSummaryColumns, setGridDataSummaryColumns] = useState(
    GridDataSummaryColumns_Def
  );

  const fOnRowClick = async (e) => {
    if (e.row.TrnTyp == "PKLST") {
      console.log("asdasd", {
        TrnTyp: e.row.TrnTyp,
        VocTyp: e.row.VocTyp,
        VocNo: e.row.VocNo,
        PDTuser: e.row.PDTuser,
        GRNDate: e.row.GRNDate,
        GRNDocTyp: e.row.GRNDocTyp,
        GrnDocNo: e.row.GrnDocNo,
        Party: e.row.Party,
        PartyName: e.row.PartyName,
        POAmt: e.row.POAmt,
        POLineItems: e.row.POLineItems,
        INVAmt: e.row.INVAmt,
        INVLineItems: e.row.INVLineItems,
        InvNo: e.row.InvNo,
        InvDt: e.row.InvDt,
        Type: e.row.Type,
        VirtualBinCd: e.row.VirtualBinCd,
        VirtualBinName: e.row.VirtualBinName,
        GRNType: e.row.GRNType,
        SrNo: e.row.SrNo,
        GRNDocTypName: e.row.GRNDocTypName,
        A_Loc: e.row.Loc,
      });

      dispatch(
        NotificationHead_Set({
          TrnTyp: e.row.TrnTyp,
          VocTyp: e.row.VocTyp,
          VocNo: e.row.VocNo,
          PDTuser: e.row.PDTuser,
          GRNDate: e.row.GRNDate,
          GRNDocTyp: e.row.GRNDocTyp,
          GrnDocNo: e.row.GrnDocNo,
          Party: e.row.Party,
          PartyName: e.row.PartyName,
          POAmt: e.row.POAmt,
          POLineItems: e.row.POLineItems,
          INVAmt: e.row.INVAmt,
          INVLineItems: e.row.INVLineItems,
          InvNo: e.row.InvNo,
          InvDt: e.row.InvDt,
          Type: e.row.Type,
          VirtualBinCd: e.row.VirtualBinCd,
          VirtualBinName: e.row.VirtualBinName,
          GRNType: e.row.GRNType,
          SrNo: e.row.SrNo,
          GRNDocTypName: e.row.GRNDocTypName,
          A_Loc: e.row.Loc,
        })
      );
      let vPickingHeadObj = {
        VocTyp: e.row.VocTyp,
        VocNo: e.row.VocNo,
      };
      const vPickingHead = await fExecuteAPI(
        "NOTIFICATION_PICKINGHEAD_GETROW",
        vPickingHeadObj
      );

      console.log("vPickingHead", vPickingHead);

      if (vPickingHead.Type == "SUCCESS") {
        const apiData = vPickingHead.ResultSet[0];
        dispatch(NotificationPickingPending_Set(apiData));

        //detailObj for pickingPendingList (make resuable) by Ramesh Sir on Dec 26 2025
        navigate("/PickingPendingList", {
          state: {
            entrySource: "Notification",
            current: "PickingPendingList",
            A_VocTyp: apiData.A_VocTyp,
            VocName: apiData.VocName,
            A_VocNo: apiData.A_VocNo,
            A_Loc: apiData.A_Loc,
            A_Typ: apiData.A_Typ,
            A_PKL_DocStatus: apiData.A_PKL_DocStatus,
            A_DocStat: apiData.A_DocStat,
            LoadingBayCode: apiData.LoadingBayCode,
            LoadingBayName: apiData.LoadingBayName,
          },
        });
      }

      // navigate("/PickingHead");
    } else if (e.row.TrnTyp == "WMINV03") {
      if (e.row.GRNType == "SALES_RETURN") {
        navigate("/WmsInboundReturn", {
          state: {
            GRNDocTyp: e?.row?.GRNDocTyp,
            GrnDocNo: e?.row?.GrnDocNo,
            RefNo: e?.row?.SrNo,
            RefVocTyp: e?.row?.VocTyp,
            RefVocNo: e?.row?.VocNo,
            RefVocName: e?.row?.VocName,
          },
        });
      } else if (e.row.GRNType == "TRANSFER_RETURN") {
        navigate("/WmsInboundOutlet", {
          state: {
            GRNDocTyp: e?.row?.GRNDocTyp,
            GrnDocNo: e?.row?.GrnDocNo,
            RefNo: e?.row?.SrNo,
            RefVocTyp: e?.row?.VocTyp,
            RefVocNo: e?.row?.VocNo,
            RefVocName: e?.row?.VocName,
          },
        });
      } else if (e.row.GRNType == "VENDOR_INV") {
        navigate("/WmsInboundVendor", {
          state: {
            GRNDocTyp: e?.row?.GRNDocTyp,
            GrnDocNo: e?.row?.GrnDocNo,
            RefNo: e?.row?.SrNo,
            RefVocTyp: e?.row?.VocTyp,
            RefVocNo: e?.row?.VocNo,
            RefVocName: e?.row?.VocName,
          },
        });
      } else {
        navigate("/WmsInboundGRN", {
          state: {
            GRNDocTyp: e?.row?.GRNDocTyp,
            GrnDocNo: e?.row?.GrnDocNo,
            RefNo: e?.row?.SrNo,
            RefVocTyp: e?.row?.VocTyp,
            RefVocNo: e?.row?.VocNo,
            RefVocName: e?.row?.VocName,
          },
        });
      }
    } else if (e.row.TrnTyp == "PUTAWAY") {
      navigate("/PutAwayDetail", {
        state: {
          GRNDocTyp: e?.row?.GRNDocTyp,
          GrnDocNo: e?.row?.GrnDocNo,
          PUTAWAYFromNotification: "Y",
        },
      });
      // navigate({
      //   pathname: "/WmsInboundGRN",
      //   search:
      //     "?GRNDocTyp=" +
      //     e.row.GRNDocTyp +
      //     "&GrnDocNo=" +
      //     e.row.GrnDocNo +
      //     "&RefVocTyp=" +
      //     e.row.VocTyp +
      //     "&RefVocNo=" +
      //     e.row.VocNo +
      //     "&RefNo=" +
      //     e.row.SrNo,
      // });
    }
  };
  //1st load
  const onLoadCall = async (e) => {
    await GetSummaryList();
  };
  //API NOTIFICATION_SUMMARY_GETROW
  const GetSummaryList = async () => {
    let vSummaryListObj = {
      UserCd: vRdxuserInfo?.UserID,
      v_InBound: filterState?.v_InBound,
      v_PutAway: filterState?.v_PutAway,
      v_Picking: filterState?.v_Picking,
      dateFrom: dayjs(filterState?.dateFrom).format("MM/DD/YYYY"),
      dateTo: dayjs(filterState?.dateTo).format("MM/DD/YYYY"),
      v_Loc:
        filterState?.v_Loc === "" ? vRdxDBLocation[0]?.UID : filterState?.v_Loc,
    };
    const vSummaryList = await fExecuteAPI(
      "NOTIFICATION_SUMMARY_GETROW",
      vSummaryListObj
    );
    if (vSummaryList.Type == "SUCCESS") {
      setShowModal(false);
      let GridID = vSummaryList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridrows(GridID);
      setShowModal(false);
      return GridID;
    } else if (vSummaryList.Type == "FAILED") {
      fAlertToast("FAILED", vSummaryList.Message);
      setGridrows([]);
      return [];
    } else {
      fAlertToast(
        "FAILED",
        vSummaryList.response.data.Status || "Error in loading summarylist"
      );
      setGridrows([]);
      return [];
    }
  };

  // console.log(vRdxDBLocation);

  useEffect(() => {
    dispatch(Set_WmsInboundGRN_HeadObject_Init());
    dispatch(Set_HeadObject_Init_Vendor());
    dispatch(Set_HeadObject_Init_Return());
    dispatch(Set_HeadObject_Init_Outlet());
    onLoadCall();
  }, []);

  // Optional: initialize location to first item if available
  // useEffect(() => {
  //   if (!filterState.v_Loc && vRdxDBLocation?.length > 0) {
  //     setFilterState((prev) => ({ ...prev, v_Loc: vRdxDBLocation[0]?.UID }));
  //   }
  // }, [vRdxDBLocation]);

  // modal end
  return (
    <div className="container-fluid my-3">
      <div className="d-flex justify-content-between align-items-center">
        <Notification_Breadcrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>

      <Grid container spacing={1}>
        {Array.isArray(sGridrows) &&
          sGridrows?.length > 0 &&
          sGridrows?.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <CardComp
                data={item}
                onClick={(item) => {
                  fOnRowClick({ row: item });
                }}
                maxHeight="123px"
                content={
                  <Grid container columnSpacing={{ xs: 2 }}>
                    <InputDisplay
                      label="Doc No"
                      value={item.GrnDocNo == "" ? item.VocNo : item.GrnDocNo}
                    />
                    <InputDisplay label="Transaction" value={item.TrnTyp} />
                    <InputDisplay
                      label="Date"
                      value={moment(item.GRNDate).format("DD/MM/YYYY")}
                    />
                    {
                      <InputDisplay
                        label="Invoice No"
                        value={item.InvNo || "-"}
                      />
                    }
                    <InputDisplay label="Party Name" value={item.PartyName} />
                  </Grid>
                }
              />
            </Grid>
          ))}
      </Grid>

      {/* <Box
                 sx={{
                   height: vMediaQuery ? "65vh" : "72vh",
                   overflowY: "auto",
                   py:vMediaQuery ?"0px" : "8px",
                   px:vMediaQuery ?"0px" : "20px",
                 }}
               >
                 <Grid container spacing={1}>
                   {Array.isArray(sGridrows) &&
                     sGridrows?.length > 0 &&
                     sGridrows?.map((item, index) => (
                       <Grid item xs={12} sm={6} md={4} key={index}>
                         <DetailCardComp
                           data={item}
                            xOnClick={() => {
            setShowModal(true);
          }}
                           headerLabel={item.TrnTyp}
                           content={
                             <Grid container spacing={1}>
                               <DetailInputDisplay
                                 label=" Doc No"
                                 value={item.GrnDocNo}
                               />
                               <DetailInputDisplay
                                 label="Date"
                                 value={moment(item.GRNDate).format("DD/MM/YYYY")}
                               />
                                 
                                  <DetailInputDisplay
                                 label="Invoice No"
                                 value={item?.InvNo}
                               />

                               <DetailInputDisplay
                                 label="PKL.PartName"
                                 value={item?.PartyName}
                               />

                               

                             </Grid>
                           }
                         />
                       </Grid>
                     ))}
                 </Grid>
               </Box> */}
      <FilterNotificationModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        filterState={filterState}
        setFilterState={setFilterState}
        vRdxDBLocation={vRdxDBLocation}
        load={GetSummaryList}
      />
    </div>
  );
}
